<template>
  <div id="inprog">
    <h3>Request in Progress</h3>
    <div class="icon">&#xe905;</div>
    <p>Our world-class travel experts are fast-tracking your request and hunting for maximum savings.</p>
  </div>
</template>

<script setup>
defineProps({
  trip: {
    type: Object,
    required: false,
  },
});
</script>

<style lang="less">
#inprog {
  background: @light;
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;

  p {
    display: block;
    margin: auto;
    margin-bottom: 2rem;
    max-width: 30rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ol {
    display: inline-block;
    margin: auto;
    max-width: 30rem;
    text-align: left;
  }

  li {
    margin-bottom: 1rem;
  }

  .icon {
    color: @green;
    font-size: 5rem;
    margin-bottom: 2rem;
  }
}
</style>
